import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterLoadingService, LoadingContext } from "../../services/router-loading.service";
import { LoadingService } from "../../services/loading.service";
import { combineLatest, map } from "rxjs";

@Component({
	selector: "app-loading-overlay",
	standalone: true,
	imports: [CommonModule, MatProgressSpinnerModule],
	templateUrl: "./loading-overlay.component.html",
	styleUrls: ["./loading-overlay.component.scss"],
})
export class LoadingOverlayComponent {
	private routerLoadingService = inject(RouterLoadingService);
	private loadingService = inject(LoadingService);

	// Combine both route loading and general loading states
	loadingState$ = combineLatest([
		this.routerLoadingService.routeLoading$,
		this.loadingService.loading$,
		this.loadingService.message$,
	]).pipe(
		map(([routeContext, generalLoading, generalMessage]) => {
			if (routeContext.isLoading) {
				return {
					isLoading: true,
					message: routeContext.message || "Loading...",
					type: "route",
				};
			} else if (generalLoading) {
				return {
					isLoading: true,
					message: generalMessage || "Loading...",
					type: "general",
				};
			}
			return {
				isLoading: false,
				message: "",
				type: "general",
			};
		}),
	);
}
